/**
 * Finnish adessive/inessive ("in {region}") form for each of the 19 maakunta (admin1) gazetteer
 * placeIds, keyed the same way `finland-region-hierarchy.json` is. There is no reliable rule for
 * which case a Finnish region name takes (mirrors the per-city table in
 * `generate-srp-seo-meta.ts`'s Finnish city grammar) so this is a curated, hand-checked table,
 * not derived.
 *
 * Used only for the on-page H1 of a maakunta hub SRP ("Avoimet työpaikat Uusimaalla"): the
 * `<title>` tag and sitemap/allowlist copy keep the nominative form ("Avoimet työpaikat Uusimaa"),
 * matching how the region reads as a plain noun phrase in a tab title.
 */
export const FINNISH_REGION_LOCATIVE: Record<string, string> = {
  '830603': 'Lapissa', // Lappi
  '830664': 'Kainuussa', // Kainuu
  '830667': 'Pohjois-Pohjanmaalla', // Pohjois-Pohjanmaa
  '830675': 'Keski-Pohjanmaalla', // Keski-Pohjanmaa
  '830676': 'Pohjanmaalla', // Pohjanmaa
  '830682': 'Etelä-Pohjanmaalla', // Etelä-Pohjanmaa
  '830685': 'Keski-Suomessa', // Keski-Suomi
  '830686': 'Pohjois-Karjalassa', // Pohjois-Karjala
  '830690': 'Pohjois-Savossa', // Pohjois-Savo
  '830695': 'Etelä-Savossa', // Etelä-Savo
  '830699': 'Etelä-Karjalassa', // Etelä-Karjala
  '830703': 'Kymenlaaksossa', // Kymenlaakso
  '830704': 'Pirkanmaalla', // Pirkanmaa
  '830705': 'Kanta-Hämeessä', // Kanta-Häme
  '830708': 'Varsinais-Suomessa', // Varsinais-Suomi (Southwest Finland)
  '830709': 'Uusimaalla', // Uusimaa
  '831040': 'Päijät-Hämeessä', // Päijät-Häme
  '831041': 'Satakunnassa', // Satakunta
  '9611692': 'Ahvenanmaalla', // Ahvenanmaa (Åland; synthetic admin1 placeId, see generate-region-tag-labels.ts)
};

/** The 19 Finnish maakunta placeIds this table must always cover (mirrors the keys of
 *  `finland-region-hierarchy.json`); kept as a small standalone list so the coverage test doesn't
 *  need to import the hierarchy JSON just to enumerate its keys. */
export const FINLAND_ADMIN1_PLACE_IDS: readonly string[] = [
  '830603', '830664', '830667', '830675', '830676', '830682', '830685', '830686',
  '830690', '830695', '830699', '830703', '830704', '830705', '830708', '830709',
  '831040', '831041', '9611692',
];

/** Returns the locative form for `placeId`, or `undefined` if it isn't a known maakunta. */
export function getFinnishRegionLocative(placeId: string): string | undefined {
  return FINNISH_REGION_LOCATIVE[placeId];
}
